var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var base64url = require('base64url');

var _require = require('did-jwt'),
    verifyJWT = _require.verifyJWT;

var encodeSection = function encodeSection(data) {
  return base64url.encode(JSON.stringify(data));
};

var TYPE = '3ID';
var JWT_HEADER = encodeSection({
  typ: 'JWT',
  alg: 'ES256K'
});

var OdbIdentityProvider = /*#__PURE__*/function () {
  "use strict";

  function OdbIdentityProvider(_ref) {
    var threeId = _ref.threeId;

    _classCallCheck(this, OdbIdentityProvider);

    // super(options)
    this.threeId = threeId;
  }

  _createClass(OdbIdentityProvider, [{
    key: "getId",
    value: function () {
      var _getId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var space;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                space = _ref2.space;

                if (!space) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.threeId.getSubDID(space));

              case 5:
                return _context.abrupt("return", this.threeId.DID);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getId(_x) {
        return _getId.apply(this, arguments);
      }

      return getId;
    }()
  }, {
    key: "signIdentity",
    value: function () {
      var _signIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, _ref3) {
        var space, payload, opts;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                space = _ref3.space;
                payload = {
                  iat: null,
                  data: data
                };
                opts = !space ? {
                  use3ID: true
                } : {
                  space: space
                };
                _context2.next = 5;
                return this.threeId.signJWT(payload, opts);

              case 5:
                return _context2.abrupt("return", _context2.sent.split('.')[2]);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signIdentity(_x2, _x3) {
        return _signIdentity.apply(this, arguments);
      }

      return signIdentity;
    }()
  }], [{
    key: "type",
    get: function get() {
      return '3ID';
    }
  }, {
    key: "setDidResolver",
    value: function () {
      var _setDidResolver = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolver) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._resolver = resolver;

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setDidResolver(_x4) {
        return _setDidResolver.apply(this, arguments);
      }

      return setDidResolver;
    }()
  }, {
    key: "verifyIdentity",
    value: function () {
      var _verifyIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(identity) {
        var payload, jwt;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this._resolver) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('The DID resolver must first be set with setDidResolver()');

              case 2:
                payload = encodeSection({
                  iat: null,
                  data: identity.publicKey + identity.signatures.id,
                  iss: identity.id
                });
                jwt = "".concat(JWT_HEADER, ".").concat(payload, ".").concat(identity.signatures.publicKey);
                _context4.prev = 4;
                _context4.next = 7;
                return verifyJWT(jwt, {
                  auth: true,
                  resolver: this._resolver
                });

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](4);
                return _context4.abrupt("return", false);

              case 12:
                return _context4.abrupt("return", true);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 9]]);
      }));

      function verifyIdentity(_x5) {
        return _verifyIdentity.apply(this, arguments);
      }

      return verifyIdentity;
    }()
  }]);

  return OdbIdentityProvider;
}();

module.exports = OdbIdentityProvider;